import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import vimeoPlayer from '@vimeo/player';

@Component({
  selector: 'app-vimeo-preview',
  templateUrl: './vimeo-preview.component.html',
})
export class VimeoPreviewComponent implements OnInit {
  @Input()
  url: string;

  title: string;
  constructor(public modal: NgbActiveModal) {}

  ngOnInit(): void {
    const player = new vimeoPlayer('videoContainer', { url: this.url });
    player.setVolume(1);
    player.getVideoTitle().then((title) => {
      this.title = title;
    });
  }
}
